<template>
    <div>
        <el-container>
            <el-header>
                <Header></Header>
            </el-header>
            
            <el-main>
                <Tab></Tab>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import Header from '../components/header';
import Tab from '../components/tab';

export default {
    components: { Header, Tab }
}

</script>



// WEBPACK FOOTER //
// src/components/home.vue